export default function animateDivs() {
  // animate on viewport
  const HIDDEN = 'animate__hidden';
  const BASE   = 'animate__animated';

  const targets = document.querySelectorAll('.' + HIDDEN);

  if ('IntersectionObserver' in window) {
    // ✅ Supported
    targets.forEach(el => {
      // Stash animation classes
      const animClasses = [...el.classList].filter(c =>
        c.startsWith('animate__') && c !== HIDDEN
      );
      if (animClasses.length) {
        el.dataset.animClasses = animClasses.join(' ');
        el.classList.remove(...animClasses); // prevent early animation
      }
    });

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const toAdd = (el.dataset.animClasses || '').split(' ').filter(Boolean);

        // force reflow before applying animations
        void el.offsetWidth;
        el.classList.add(BASE, ...toAdd);
        el.classList.remove(HIDDEN);

        obs.unobserve(el); // animate once
      });
    }, { threshold: 0.15 }); // when 15% of the element is visible

    targets.forEach(el => observer.observe(el));

  } else {
    // ❌ Not supported → just show everything without animation
    targets.forEach(el => {
      el.classList.remove(HIDDEN);
    });
  }
}
